export const HORECA_LOCATOR_BUILDER_COMPONENT_NAME = "HoReCaLocator";
